// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  Impact,
} from "./types";


export default __t.row({
  alertname: __t.string().primaryKey(),
  components: __t.array(__t.string()),
  get impact() {
    return Impact;
  },
  titleTemplate: __t.string().name("title_template"),
  enabled: __t.bool(),
});
